<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-12 text-center" style="overflow: hidden !important">
        <img
          v-if="address == null"
          @click="clickUploader(Idu)"
          class="w-100 Pointer"
          src="/Image/OHUploader.png"
        />
        <img
          v-else
          @click="clickUploader(Idu)"
          style="height: 18vh"
          :src="address"
        />
        <input
          @change="whithName ? void 0 : uploadFIle(Idu)"
          :id="Idu"
          type="file"
          class="d-none"
        />
      </div>
      <div class="col-12">
        <div class="row">
          <div class="col-12 p-3 text-center font-weight-bold">
            {{ title }}
            <i
              v-if="address != null"
              title="حذف فایل"
              class="fas fa-trash mx-2 text-danger float-left Pointer"
              @click="DeleteImage(attachId)"
            ></i>
            <a
              v-if="address != null"
              class="mx-2"
              :download="base64.filename"
              title="دانلود فایل"
              :href="'data:application/octet-stream;base64,' + base64.binary"
            >
              <i class="fas fa-download text-success float-left Pointer"></i>
            </a>
          </div>
        </div>
        <div v-if="whithName" class="row">
          <div class="col-12">
            <input
              type="text"
              style="font-size: 12px !important"
              placeholder="نام فایل"
              v-model="FileName"
              class="form-control"
            />
          </div>

          <div class="col-12">
            <slot name="uploaderCombo"> </slot>
          </div>

          <div class="col-12 mt-2">
            <button @click="uploadFIle(Idu)" class="btn btn-primary w-100">
              بارگذاری
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: [
    "Idu",
    "attachId",
    "address",
    "grp",
    "MasterId",
    "title",
    "base64",
    "TableName",
    "whithName",
  ],
  data() {
    return {
      FileName: "",
    };
  },
  methods: {
    clickUploader(Id) {
      document.getElementById(Id).click();
    },
    uploadFIle(Id, e) {
      this.loadingRender = true;
      const input = document.getElementById(Id);
      if (input.files && input.files[0]) {
        var file = input.files[0];
        if (file.size > 5 * 1024 * 1024) {
          this.$mySweetDefaultTost(
            "هشدار",
            "حجم فایل ارسالی باید کمتر از 5 مگابایت باشد",
            "warning",
            2000,
          );
          input.files = null;
        } else {
          if (this.CheckExtension(file.name)) {
            this.SendToApi(file);
          } else {
            this.$mySweetDefaultTost(
              "هشدار",
              "فرمت فایل پشتیبانی نمیشود!",
              "warning",
              2000,
            );
            input.files = null;
          }
        }
      }
    },
    SendToApi(file) {
      const formData = new FormData();
      formData.append("Id", this.attachId ? this.attachId : 11);
      formData.append("MasterId", this.MasterId);
      formData.append("wwwtblcomboidgrp328", Number(this.grp));
      formData.append("Filename", this.FileName);
      formData.append("Filepath", "");
      formData.append(
        "TableName",
        this.TableName ? this.TableName : "wwwtblaza",
      );
      formData.append("image", file);
      var dataAxiosupload = {
        Method: "POST",
        Action: "Uploader",
        ArryfildValue: formData,
      };
      this.$PostFormData(dataAxiosupload).then((result) => {
        this.loadingRender = false;
        this.$mySweetDefaultTost(result.title, result.msg, result.icon, 2000);
        this.$emit("Done", true);
      });
    },
    Remove(Id) {
      var axios = {
        Method: "POST",
        Action: "Uploader/Delete",
        ArryfildValue: { Id: Id },
      };
      this.$PostData(axios).then((result) => {
        this.$mySweetDefaultTost(result.title, result.msg, result.icon, 2000);
        this.$emit("Done", true);
      });
    },
    DeleteImage(Id) {
      this.$SweetQustion(
        "هشدار",
        "ایا از حذف این مدرک اطمینان دارید؟",
        "warning",
        "بله، حذف شود",
        "خیر",
        Id,
        this.Remove,
        this.Cancel,
      );
    },
    CheckExtension(FileName) {
      var ex = FileName.split(".").pop();
      return ["rar", "zip", "png", "jpg", "jpeg", "pdf"].includes(ex);
    },
    Cancel() {},
  },
};
</script>
